// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import React, { forwardRef, useContext } from 'react';
import cn from 'classnames';
import _ from 'zutil';
import { useHistory } from 'react-router-dom';
import { Trans as T, useTranslation } from 'react-i18next';
import hopt from 'hola_opt';
import { Plus_plans } from '../../plus/plans.js';
import plans_util from '../../plans_util.js';
import { Settings_context } from '../../settings_ctx';
import { Navbar_logo } from './navbar_logo.js';
import { use_was_opened } from './use_was_opened';
import styles from './plus_menu.module.less';
var Benefits = ({
  to
}) => {
  var _useContext = useContext(Settings_context),
    theme_name = _useContext.theme_name;
  var type = 'premium';
  var devices = '10';
  var quality = 'HD';
  var support = 'Email';
  return /*#__PURE__*/React.createElement("div", {
    className: styles.benefits
  }, /*#__PURE__*/React.createElement(Navbar_logo, {
    type: type,
    to: `${to}?ref=navbar_plans_benefits`,
    dark: theme_name == 'dark'
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, null, devices, " connected devices at the same time")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, null, "Unlimited usage")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, null, quality, " video streaming quality")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, null, support, " customer support")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, null, "Super fast servers worldwide"))));
};
var Plus_menu = /*#__PURE__*/forwardRef((props, ref) => {
  useTranslation();
  var history = useHistory();
  var opened = props.opened;
  var plan_ids = hopt.join_plus.plan_ids;
  var plans = _.values(plans_util.get_plans_info(plan_ids)).slice();
  var best = _.min_by(plans, p => p.month_price);
  var to = '/premium';
  var set_plan = plan => {
    history.push(`${to}?ref=navbar_plans_menu&plan_id=${plan.id}`);
  };
  var was_opened = use_was_opened(opened);
  var cls = cn(styles.plus_menu, !opened && styles.closed);
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, was_opened && /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Benefits, {
    to: to
  }), /*#__PURE__*/React.createElement(Plus_plans, {
    cls: "payment-plans-navbar",
    plans: plans,
    best: best,
    set_plan: set_plan,
    currency: 'USD',
    short: true
  })));
});
export { Plus_menu };